import React from "react";
import {
  getEventPositionTimeLine,
  handleTaskNameClick,
} from "../../../helper/helper";
import TastStatus from "../../../TastStatus/TastStatus";
import CalendarTaskCard from "../../CalendarTaskCard/CalendarTaskCard";
import { maxTasksInRow } from "../../../calendar";

const List = ({ updatedTasks = [], selectedDate }) => {
  return (
    <>
      {updatedTasks.map((event) => {
        const { startPosition = 0, endPosition = 0 } =
          getEventPositionTimeLine(event, selectedDate) || {};
        const eventHeight = endPosition - startPosition;
        let width = 75;
        if (event.overlapCount !== 1)
          width =
            100 /
            (event.overlapCount > maxTasksInRow
              ? maxTasksInRow
              : event.overlapCount);
        return (
          <div
            role="appointment-card"
            onClick={() => handleTaskNameClick(event)}
            key={event.userTaskId}
            className={`calendar-task overflow-ellipsis`}
            style={{
              top: `${startPosition}px`,
              left: `${
                (event.position * 100) /
                (event.overlapCount > maxTasksInRow
                  ? maxTasksInRow
                  : event.overlapCount)
              }%`,
              height: `${eventHeight}px`,
              width: `calc(${width}% - 4px)`,
            }}
          >
            <TastStatus event={event} />
            <CalendarTaskCard event={event} showLead={eventHeight >= 45} />
          </div>
        );
      })}
    </>
  );
};

export default List;
